export { default as MenuPills } from "./Pills";
